
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[id]",
      function () {
        return require("private-next-pages/profile/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[id]"])
      });
    }
  